/*document.addEventListener('DOMContentLoaded', function () {*/
    function updatePopupCart() {
        //console.log('updatePopupCart starts');
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartItemsContainer = document.getElementById('cart-items');
                cartItemsContainer.innerHTML = '';

                var count = 0;
                let imagePromises = [];

                cart.items.forEach(item => {
                    const itemElement = document.createElement('div');
                    var productImageUrl = `${item.image}?width=52&height=78&crop=center`;
                    itemElement.classList.add('cart-item');
                    itemElement.innerHTML = `
                        <div class="popup-cart_image-container">
                          <a href="${item.url}">
                            <img src="${productImageUrl}" alt="" style="width:65px; height:97.5px;"/>
                          </a>
                        </div>
                        <div class="popup-cart_info">
                            <div class="trash-icon remove-item" data-variant-id="${item.variant_id}">
                              <svg width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M160 256H96a32 32 0 0 1 0-64h256V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64h-64v672a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V256zm448-64v-64H416v64h192zM224 896h576V256H224v640zm192-128a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32zm192 0a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32z"/></svg>
                            </div>
                            <a href="${item.url}" class="popup-cart_info">${item.product_title}</a>
                            <div class="popup-cart_info">${item.variant_title}</div>
                            <div class="popup-cart_info" style="font-weight:200;">${item.quantity}X</div>
                            <div class="popup-cart_price">$${(item.price / 100).toFixed(2)}</div>
                        </div>
                    `;
                    cartItemsContainer.appendChild(itemElement);
                    count++;

                    /*let img = itemElement.querySelector('img');
                    let imgPromise = new Promise((resolve) => {
                        img.onload = () => {
                            img.style.display = 'block';
                            resolve();
                        };
                        img.src = productImageUrl;
                    });
                    imagePromises.push(imgPromise);*/
                });

                if (count >= 3) {
                  document.getElementById('cart-items').classList.add("large-cart");
                } else if (count < 3) {
                  if (document.getElementById('cart-items').classList.contains("large-cart")) {
                    document.getElementById('cart-items').classList.remove("large-cart");
                  }
                }

                document.getElementById('cart-total-price').textContent = (cart.total_price / 100).toFixed(2);
;

                document.querySelectorAll('.remove-item').forEach(button => {
                    button.addEventListener('click', function () {
                        const variantId = this.getAttribute('data-variant-id');
                        const itemElement = this.closest('.cart-item');
                        itemElement.style.opacity = '0.5'; // Change opacity while removing
                        removeItemFromCart(variantId);
                    });
                });

               // Close the cart if no items are left
               if (cart.item_count === 0 ) {
                    hidePopupCart();
                }

                updateCartCount(cart.item_count);

                document.getElementById('popup-cart').style.display = 'flex';
                document.getElementById('popup-cart').classList.add('fade-in');
                document.body.classList.add("popup-cart_open");

                /*Promise.all(imagePromises).then(() => {
                    document.getElementById('popup-cart').style.display = 'flex';
                    document.getElementById('popup-cart').classList.add('fade-in');
                    document.body.classList.add("popup-cart_open");
                });*/
            });
    }

    function removeItemFromCart(variantId) {
        fetch(`/cart/change.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ id: variantId, quantity: 0 }),
        }).then(response => {
            if (response.ok) {
                updatePopupCart();
            }
        });
    }

    function showPopupCart() {
        updatePopupCart();
        //console.log('ShowPopupCart started');
    }

    function hidePopupCart() {
        document.getElementById('popup-cart').style.display = 'none';
        document.body.classList.remove("popup-cart_open");
    }

    function addProductToCart(variantId, quantity = 1) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
        }).then(response => {
            if (response.ok) {
                showPopupCart();
                const quick_modal = document.querySelector('quick-add-modal');
                if (!quick_modal) {
                  //console.log('quick modal was not found');
                  return;
                } else {
                  //console.log('quick modal was found');
                  const closeButton = quick_modal.querySelector('[aria-label="Close"]');
                  if (closeButton) {
                    closeButton.click();
                  }
                }
            }
        });
    }

    function updateCartCount(count) {
        let cartCountBubble = document.querySelector('.cart-count-bubble');

        if (!cartCountBubble && count > 0) {
            // Create the cart-count-bubble element if it does not exist and count is greater than 0
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            cartCountBubble = document.createElement('div');
            cartCountBubble.classList.add('cart-count-bubble');
            cartCountBubble.innerHTML = `
                <span aria-hidden="true">${count}</span>
                <span class="visually-hidden">${count} items</span>
            `;
            cartIconBubble.appendChild(cartCountBubble);
        } else if (cartCountBubble) {
            // Update the cart-count-bubble element if it exists
            const spans = cartCountBubble.querySelectorAll('span');
            spans[0].textContent = count;
            spans[1].textContent = `${count} items`;
        }

        // Hide the popup cart if the item count is zero
        if (count === 0) {
            hidePopupCart();
        }
    }

    document.querySelectorAll('body .add-to-cart').forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            const form = this.closest('form');
            const variantId = form.querySelector('[name="id"]').value;
            addProductToCart(variantId);
        });
    });

    document.querySelector('.close-button').addEventListener('click', function () {
        hidePopupCart();
    });

    document.getElementById('continue-shopping').addEventListener('click', function () {
        hidePopupCart();
    });

    document.getElementById('view-cart').addEventListener('click', function () {
        window.location.href = '/cart';
    });

    // Temporary button to open popup cart for design purposes
    document.getElementById('open-popup-cart').addEventListener('click', function () {
        showPopupCart();
    });

    // Initial update of cart count on page load
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            updateCartCount(cart.item_count);
        });

    // Close popup cart when clicking or tapping outside of .popup-cart-content
    function outsideClickListener(event) {
        const popupCartContent = document.querySelector('.popup-cart-content');
        if (!popupCartContent.contains(event.target) && !event.target.matches('.add-to-cart, .remove-item, .close-button')) {
            hidePopupCart();
        }
    }

    document.addEventListener('click', outsideClickListener);
    document.addEventListener('touchstart', outsideClickListener);

    //console.log('pop up cart js loaded');
/*});*/
